module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('section', {
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('api-request', {
    staticClass: "full-width",
    attrs: {
      "resource": _vm.$api.fakeRequest(2000),
      "effect": "lightSpeedIn",
      "spinner": "DotLoader",
      "spinner-color": "#FC6194",
      "spinner-scale": 2
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-md-8 col-md-offset-2"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/v-api@512.png"),
      "alt": "Vue Api Request"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "v-api-logo"
  }, [_vm._v("API REQUEST")]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(2500),
      "effect": "zoomIn",
      "spinner": "SyncLoader",
      "spinner-color": "#FC6194",
      "spinner-scale": 1,
      "spinner-padding": "32px"
    }
  }, [_c('h1', [_vm._v("Documentation")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(3500),
      "effect": "bounceIn",
      "spinner": "MoonLoader",
      "spinnerColor": "#FC6194",
      "spinnerScale": 0.7,
      "spinnerPadding": "8px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        _vm.scrollTo('#summary')
      }
    }
  }, [_vm._v("\n                Getting Started & Examples\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-info btn-lg",
    attrs: {
      "href": "//github.com/ftgibran/vue-api-request",
      "target": "_blank"
    }
  }, [_vm._v("\n                View on Github\n              ")])])], 1)])])], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Summary")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('fieldset', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "list-unstyled col-md-6 col-md-offset-3"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#getting-started')
      }
    }
  }, [_vm._v("Getting Started")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#installation')
      }
    }
  }, [_vm._v("Installation")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#basic-usage')
      }
    }
  }, [_vm._v("Basic Usage")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#pre-configuration')
      }
    }
  }, [_vm._v("Pre Configuration")])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#explanations')
      }
    }
  }, [_vm._v("Explanations & Examples")]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_1')
      }
    }
  }, [_vm._v("First Step")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_2')
      }
    }
  }, [_vm._v("Request with Params")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_3')
      }
    }
  }, [_vm._v("Fake Requests")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_4')
      }
    }
  }, [_vm._v("Global Request Access from $api")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_5')
      }
    }
  }, [_vm._v("Trigger & Sync Requests using Waiting Slot")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_6')
      }
    }
  }, [_vm._v("Conditional Request")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_7')
      }
    }
  }, [_vm._v("Using Events")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_8')
      }
    }
  }, [_vm._v("Serial Requests")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_9')
      }
    }
  }, [_vm._v("Parallel Requests")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_10')
      }
    }
  }, [_vm._v("Customize")])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#api')
      }
    }
  }, [_vm._v("API Reference")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#props')
      }
    }
  }, [_vm._v("Props")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#events')
      }
    }
  }, [_vm._v("Events")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#slots')
      }
    }
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#methods')
      }
    }
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#conf-methods')
      }
    }
  }, [_vm._v("Configuration Methods")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#conf-options')
      }
    }
  }, [_vm._v("Configuration Options")])])])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "getting-started"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Getting Started")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "installation"
    }
  }, [_c('h3', [_vm._v("Installation")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.code['installation'][0])
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.code['installation'][1])
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['installation'][2]))
    }
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "basic-usage"
    }
  }, [_c('h3', [_vm._v("Basic Usage")]), _vm._v(" "), _c('p', [_vm._v("\n          You have to import the library and use as a Vue plugin to enable the functionality globally on all components.\n        ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['basicUsage'][0]))
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Example")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['basicUsage'][1]))
    }
  })]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "pre-configuration"
    }
  }, [_c('h3', [_vm._v("Pre Configuration")]), _vm._v(" "), _c('p', [_vm._v("\n          You may also set your own default configuration, so you don't need to customize every time each ApiRequest component. You are still able to customize a specific component using props.\n          Go to section "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#conf-options')
      }
    }
  }, [_vm._v("API - Configuration Options")]), _vm._v(" to further information.\n        ")]), _vm._v(" "), _c('h4', [_vm._v("Example")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['preConfiguration'][0]))
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n          The 'options' variable above is equivalent of:\n        ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['preConfiguration'][1]))
    }
  })])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "explanations"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Explanations & Examples")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_1"
    }
  }, [_c('h3', [_vm._v("1. First Step")]), _vm._v(" "), _c('p', [_vm._v("\n          Vue API Request provides a full control on your APIs, making the calls simple, fast and easy to implement.\n          Also, your code will be cleaner and more elegant.\n        ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h4', [_vm._v("Example")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][0][0]))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('firstExample')
      }
    }
  }, [_vm._v("Reload Example")])]), _vm._v(" "), _c('h4', [_vm._v("Result")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.example.firstExample.show) ? _c('api-request', {
    attrs: {
      "resource": _vm.$api.giphyRandom
    },
    model: {
      value: (_vm.example.firstExample.response),
      callback: function($$v) {
        _vm.example.firstExample.response = $$v
      },
      expression: "example.firstExample.response"
    }
  }, [(_vm.example.firstExample.response.body) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.example.firstExample.response.body.data.image_url,
      "alt": "giphy"
    }
  }) : _vm._e()]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', [_vm._v("Response")]), _vm._v(" "), _c('pre', [_vm._v("myResponse = " + _vm._s(_vm.example.firstExample.response))])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_2"
    }
  }, [_c('h3', [_vm._v("2. Request with Params")]), _vm._v(" "), _c('h4', [_vm._v("Simple parameter")]), _vm._v(" "), _c('p', [_vm._v("If you only need a unique param, all you need is:")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][1][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][1][1]))
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Multiple parameters")]), _vm._v(" "), _c('p', [_vm._v("If you use more than one param, you have to use your param as an object:")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][1][2]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][1][3]))
    }
  }), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_3"
    }
  }, [_c('h3', [_vm._v("3. Fake Requests")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('h4', [_vm._v("Example")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][2][0]))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('fakeExample')
      }
    }
  }, [_vm._v("Reload Example")])]), _vm._v(" "), _c('h4', [_vm._v("Result")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.example.fakeExample.show) ? _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(3000, 'My fake Request')
    },
    model: {
      value: (_vm.example.fakeExample.response),
      callback: function($$v) {
        _vm.example.fakeExample.response = $$v
      },
      expression: "example.fakeExample.response"
    }
  }, [_vm._v("\n                  Hello, I am a fake request and my response is: "), _c('code', [_vm._v(_vm._s(_vm.example.fakeExample.response))])]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_4"
    }
  }, [_c('h3', [_vm._v("4. Global Request Access from $api")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][3][0]))
    }
  }), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][3][1]))
    }
  }), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('h4', [_vm._v("Example")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][3][2]))
    }
  })]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_5"
    }
  }, [_c('h3', [_vm._v("5. Trigger & Sync Requests using Waiting Slot")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('h4', [_vm._v("Example with trigger.sync")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._m(17), _vm._v(" "), _c('p', [_vm._v("\n            If you have an older version, use\n            "), _c('strong', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#methods_fetch')
      }
    }
  }, [_vm._v("\n                fetch method\n              ")])]), _vm._v(".\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][4][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][4][1]))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [_c('div', [_c('a', {
    staticClass: "btn btn-default btn-lg",
    style: ({
      width: '120px'
    }),
    on: {
      "click": function($event) {
        _vm.example.likeExample.trigger = true
      }
    }
  }, [_c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(1000, !_vm.example.likeExample.liked),
      "trigger": _vm.example.likeExample.trigger,
      "spinner-scale": 0.55,
      "spinner-padding": 0
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.likeExample.trigger = $event
      }
    },
    model: {
      value: (_vm.example.likeExample.liked),
      callback: function($$v) {
        _vm.example.likeExample.liked = $$v
      },
      expression: "example.likeExample.liked"
    }
  }, [_c('span', {
    slot: "waiting"
  }, [_vm._v("\n                    " + _vm._s(_vm.example.likeExample.liked ? 'You liked' : 'Like') + "\n                ")])])], 1)])])])])]), _vm._v(" "), _c('h4', [_vm._v("Example with sync and trigger.sync")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][4][2]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][4][3]))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('triggerExample')
      }
    }
  }, [_vm._v("Reload Example")])]), _vm._v(" "), _c('h4', [_vm._v("Result")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [_c('div', [(_vm.example.triggerExample.show) ? _c('api-request', {
    staticClass: "div-section",
    style: ({
      minHeight: '250px'
    }),
    attrs: {
      "resource": _vm.$api.giphySearch,
      "params": {
        q: _vm.example.triggerExample.q,
        offset: _vm.example.triggerExample.offset,
        limit: 3
      },
      "trigger": _vm.example.triggerExample.trigger,
      "sync": _vm.example.triggerExample.offset
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.triggerExample.trigger = $event
      }
    },
    model: {
      value: (_vm.example.triggerExample.response),
      callback: function($$v) {
        _vm.example.triggerExample.response = $$v
      },
      expression: "example.triggerExample.response"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.example.triggerExample.trigger = true
      }
    },
    slot: "waiting"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-md-4 col-md-offset-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.example.triggerExample.q),
      expression: "example.triggerExample.q"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Type something"
    },
    domProps: {
      "value": (_vm.example.triggerExample.q)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.example.triggerExample.q = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Search")])])]), _vm._v(" "), _c('div', {
    slot: "success"
  }, [(_vm.example.triggerExample.response.body) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.example.triggerExample.response.body.data), function(item) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('img', {
      staticClass: "img-responsive",
      style: ({
        maxHeight: '250px'
      }),
      attrs: {
        "src": item.images.fixed_width.url,
        "alt": "giphy"
      }
    })])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    slot: "error"
  }, [_vm._v("\n                  Error loading this page!\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.example.triggerExample.response.body) ? _c('ul', {
    staticClass: "list-inline"
  }, [_c('li', [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.triggerExample.offset -= _vm.example.triggerExample.offset == 0 ? 0 : 3
      }
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), _c('li', [_vm._v("\n                  " + _vm._s(_vm.example.triggerExample.offset / 3 + 1) + "\n                ")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.triggerExample.offset += 3
      }
    }
  }, [_vm._v("Next")])])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_c('h4', [_vm._v("Multi variables in Sync")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('br'), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][4][4]))
    }
  })])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_6"
    }
  }, [_c('h3', [_vm._v("6. Conditional Request")]), _vm._v("\n\n        Conditional request gives you one more option to easily control your requests.\n\n        "), _c('h4', [_vm._v("Example")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][5][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][5][1]))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [_c('api-request', {
    attrs: {
      "resource": _vm.$api.giphyRandom,
      "trigger": _vm.example.conditionalExample.trigger,
      "only-if": _vm.example.conditionalExample.canRefresh
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.conditionalExample.trigger = $event
      }
    },
    model: {
      value: (_vm.example.conditionalExample.response),
      callback: function($$v) {
        _vm.example.conditionalExample.response = $$v
      },
      expression: "example.conditionalExample.response"
    }
  }, [_c('ul', {
    staticClass: "list-inline"
  }, [_c('li', [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.example.conditionalExample.canRefresh),
      expression: "example.conditionalExample.canRefresh"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.example.conditionalExample.canRefresh) ? _vm._i(_vm.example.conditionalExample.canRefresh, null) > -1 : (_vm.example.conditionalExample.canRefresh)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.example.conditionalExample.canRefresh,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.example.conditionalExample.canRefresh = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.example.conditionalExample.canRefresh = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.example.conditionalExample.canRefresh = $$c
        }
      }
    }
  }), _vm._v(" Can Refresh\n                        ")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.conditionalExample.trigger = true
      }
    }
  }, [_vm._v("Refresh GIF")])])]), _vm._v(" "), (_vm.example.conditionalExample.response) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.example.conditionalExample.response.body.data.image_url,
      "alt": "giphy"
    }
  }) : _vm._e()])], 1)])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_7"
    }
  }, [_c('h3', [_vm._v("7. Using Events")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][6][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][6][1]))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(!_vm.example.eventsExample.show) ? _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('eventsExample')
      }
    }
  }, [_vm._v("Reveal Example")]) : _vm._e()]), _vm._v(" "), _c('h4', [_vm._v("Result")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.example.eventsExample.show) ? _c('div', [_c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(1000),
      "trigger": _vm.example.eventsExample.triggerWaiting
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.eventsExample.triggerWaiting = $event
      },
      "waiting": _vm.example.eventsExample.waiting
    }
  }, [_c('div', {
    slot: "waiting"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.eventsExample.triggerWaiting = true
      }
    }
  }, [_vm._v("Waiting Example")])])]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(1000),
      "trigger": _vm.example.eventsExample.triggerLoading
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.eventsExample.triggerLoading = $event
      },
      "loading": _vm.example.eventsExample.loading
    }
  }, [_c('div', {
    slot: "waiting"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.eventsExample.triggerLoading = true
      }
    }
  }, [_vm._v("Loading Example")])])]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(1000, 'successResp'),
      "trigger": _vm.example.eventsExample.triggerSuccess
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.eventsExample.triggerSuccess = $event
      },
      "success": _vm.example.eventsExample.success
    }
  }, [_c('div', {
    slot: "waiting"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.eventsExample.triggerSuccess = true
      }
    }
  }, [_vm._v("Success Example")])]), _vm._v(" "), _c('div', {
    slot: "success"
  }, [_vm._v("Success")])]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequestError(1000, 'errorResp'),
      "trigger": _vm.example.eventsExample.triggerError
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.eventsExample.triggerError = $event
      },
      "error": _vm.example.eventsExample.error
    }
  }, [_c('div', {
    slot: "waiting"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.eventsExample.triggerError = true
      }
    }
  }, [_vm._v("Error Example")])]), _vm._v(" "), _c('div', {
    slot: "error"
  }, [_vm._v("Error")])]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(1000, 'loadedResp'),
      "trigger": _vm.example.eventsExample.triggerLoaded
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.eventsExample.triggerLoaded = $event
      },
      "loaded": _vm.example.eventsExample.loaded
    }
  }, [_c('div', {
    slot: "waiting"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.eventsExample.triggerLoaded = true
      }
    }
  }, [_vm._v("Loaded Example")])]), _vm._v(" "), _c('div', {
    slot: "loaded"
  }, [_vm._v("Loaded")])])], 1) : _vm._e()])])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_8"
    }
  }, [_c('h3', [_vm._v("8. Serial Requests")]), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][7][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][7][1]))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('serialExample')
      }
    }
  }, [_vm._v("Reload Example")])]), _vm._v(" "), _c('h4', [_vm._v("Result")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.example.serialExample.show) ? _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(1000, 'First Response'),
      "trigger": _vm.example.serialExample.trigger,
      "effect": "flipInX"
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.serialExample.trigger = $event
      }
    },
    model: {
      value: (_vm.example.serialExample.response1),
      callback: function($$v) {
        _vm.example.serialExample.response1 = $$v
      },
      expression: "example.serialExample.response1"
    }
  }, [_c('div', {
    slot: "waiting"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.serialExample.trigger = true
      }
    }
  }, [_vm._v("Do serial request")])]), _vm._v(" "), _c('div', {
    slot: "success"
  }, [_c('img', {
    style: ({
      width: '200px'
    }),
    attrs: {
      "src": "/static/v-api@512.png",
      "alt": "vue-api-request"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.example.serialExample.response1))]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(1500, 'Second Response'),
      "effect": "flipInY"
    },
    model: {
      value: (_vm.example.serialExample.response2),
      callback: function($$v) {
        _vm.example.serialExample.response2 = $$v
      },
      expression: "example.serialExample.response2"
    }
  }, [_c('img', {
    style: ({
      width: '200px'
    }),
    attrs: {
      "src": "/static/v-api@512.png",
      "alt": "vue-api-request"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.example.serialExample.response2))]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(2000, 'Third Response'),
      "effect": "zoomIn"
    },
    model: {
      value: (_vm.example.serialExample.response3),
      callback: function($$v) {
        _vm.example.serialExample.response3 = $$v
      },
      expression: "example.serialExample.response3"
    }
  }, [_c('img', {
    style: ({
      width: '200px'
    }),
    attrs: {
      "src": "/static/v-api@512.png",
      "alt": "vue-api-request"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.example.serialExample.response3))])])], 1)], 1)]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_9"
    }
  }, [_c('h3', [_vm._v("9. Parallel Requests")]), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][8][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][8][1]))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('parallelExample')
      }
    }
  }, [_vm._v("Reload Example")])]), _vm._v(" "), _c('h4', [_vm._v("Result")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.example.parallelExample.show) ? _c('api-request', {
    attrs: {
      "resource": _vm.example.parallelExample.resource(_vm.$api),
      "trigger": _vm.example.parallelExample.trigger
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.parallelExample.trigger = $event
      }
    },
    model: {
      value: (_vm.example.parallelExample.response),
      callback: function($$v) {
        _vm.example.parallelExample.response = $$v
      },
      expression: "example.parallelExample.response"
    }
  }, [_c('form', {
    slot: "waiting"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.parallelExample.trigger = true
      }
    }
  }, [_vm._v("Do parallel request")])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    slot: "success"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    style: ({
      width: '200px'
    }),
    attrs: {
      "src": "/static/v-api@512.png",
      "alt": "vue-api-request"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.example.parallelExample.response.request1))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    style: ({
      width: '200px'
    }),
    attrs: {
      "src": "/static/v-api@512.png",
      "alt": "vue-api-request"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.example.parallelExample.response.request2))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    style: ({
      width: '200px'
    }),
    attrs: {
      "src": "/static/v-api@512.png",
      "alt": "vue-api-request"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.example.parallelExample.response.request3))])])])]) : _vm._e()], 1)])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_10"
    }
  }, [_c('h3', [_vm._v("10. Customize")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_vm._m(27), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [_c('div', {
    staticClass: "row free-customize"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4 text-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customize-effect"
    }
  }, [_vm._v("Effect")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.example.customizeExample.effect),
      expression: "example.customizeExample.effect"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "customize-effect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.example.customizeExample.effect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "fadeIn"
    }
  }, [_vm._v("fadeIn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fadeInDown"
    }
  }, [_vm._v("fadeInDown")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fadeInUp"
    }
  }, [_vm._v("fadeInUp")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "zoomIn"
    }
  }, [_vm._v("zoomIn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "zoomInDown"
    }
  }, [_vm._v("zoomInDown")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "zoomInUp"
    }
  }, [_vm._v("zoomInUp")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bounceIn"
    }
  }, [_vm._v("bounceIn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "flipInX"
    }
  }, [_vm._v("flipInX")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "flipInY"
    }
  }, [_vm._v("flipInY")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lightSpeedIn"
    }
  }, [_vm._v("lightSpeedIn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rotateInDownLeft"
    }
  }, [_vm._v("rotateInDownLeft")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rotateInDownRight"
    }
  }, [_vm._v("rotateInDownRight")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rotateInUpLeft"
    }
  }, [_vm._v("rotateInUpLeft")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rotateInUpRight"
    }
  }, [_vm._v("rotateInUpRight")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rollIn"
    }
  }, [_vm._v("rollIn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bounce"
    }
  }, [_vm._v("bounce")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "flash"
    }
  }, [_vm._v("flash")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pulse"
    }
  }, [_vm._v("pulse")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rubberBand"
    }
  }, [_vm._v("rubberBand")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "shake"
    }
  }, [_vm._v("shake")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "swing"
    }
  }, [_vm._v("swing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "tada"
    }
  }, [_vm._v("tada")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "wobble"
    }
  }, [_vm._v("wobble")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "jello"
    }
  }, [_vm._v("jello")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customize-spinner"
    }
  }, [_vm._v("Spinner")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.example.customizeExample.spinner),
      expression: "example.customizeExample.spinner"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "customize-spinner"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.example.customizeExample.spinner = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PulseLoader"
    }
  }, [_vm._v("PulseLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GridLoader"
    }
  }, [_vm._v("GridLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ClipLoader"
    }
  }, [_vm._v("ClipLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RiseLoader"
    }
  }, [_vm._v("RiseLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BeatLoader"
    }
  }, [_vm._v("BeatLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SyncLoader"
    }
  }, [_vm._v("SyncLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RotateLoader"
    }
  }, [_vm._v("RotateLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FadeLoader"
    }
  }, [_vm._v("FadeLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PacmanLoader"
    }
  }, [_vm._v("PacmanLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SquareLoader"
    }
  }, [_vm._v("SquareLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ScaleLoader"
    }
  }, [_vm._v("ScaleLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SkewLoader"
    }
  }, [_vm._v("SkewLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MoonLoader"
    }
  }, [_vm._v("MoonLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RingLoader"
    }
  }, [_vm._v("RingLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BounceLoader"
    }
  }, [_vm._v("BounceLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DotLoader"
    }
  }, [_vm._v("DotLoader")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customize-spinner-color"
    }
  }, [_vm._v("Spinner Color")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.example.customizeExample.spinnerColor),
      expression: "example.customizeExample.spinnerColor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "customize-spinner-color"
    },
    domProps: {
      "value": (_vm.example.customizeExample.spinnerColor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.example.customizeExample.spinnerColor = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customize-spinner-padding"
    }
  }, [_vm._v("Spinner Padding")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.example.customizeExample.spinnerPadding),
      expression: "example.customizeExample.spinnerPadding"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "customize-spinner-padding"
    },
    domProps: {
      "value": (_vm.example.customizeExample.spinnerPadding)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.example.customizeExample.spinnerPadding = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customize-spinner-scale"
    }
  }, [_vm._v("Spinner Scale")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.example.customizeExample.spinnerScale),
      expression: "example.customizeExample.spinnerScale"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "5",
      "id": "customize-spinner-scale"
    },
    domProps: {
      "value": (_vm.example.customizeExample.spinnerScale)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.example.customizeExample.spinnerScale = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        _vm.reset('customizeExample', true)
      }
    }
  }, [_vm._v("Make")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [(_vm.example.customizeExample.show) ? _c('api-request', {
    style: ({
      maxWidth: '100%',
      marginBottom: '1em',
      border: '1px solid #ccc',
      position: 'relative',
      zIndex: '1'
    }),
    attrs: {
      "resource": _vm.$api.fakeRequest(2500),
      "effect": _vm.example.customizeExample.effect,
      "spinner": _vm.example.customizeExample.spinner,
      "spinner-color": _vm.example.customizeExample.spinnerColor,
      "spinner-padding": _vm.example.customizeExample.spinnerPadding,
      "spinner-scale": _vm.example.customizeExample.spinnerScale
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/v-api@512.png"),
      "alt": "Vue Api Request"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4 text-left"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['freeCustomize']({
        effect: _vm.example.customizeExample.effect,
        spinner: _vm.example.customizeExample.spinner,
        spinnerColor: _vm.example.customizeExample.spinnerColor,
        spinnerPadding: _vm.example.customizeExample.spinnerPadding,
        spinnerScale: _vm.example.customizeExample.spinnerScale
      })))
    }
  })])])])]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "creating-effect"
    }
  }, [_vm._v("Creating your own effect")]), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][9][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][9][1]))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('customEffectExample')
      }
    }
  }, [_vm._v("Show Effect")])]), _vm._v(" "), _c('h4', [_vm._v("Example")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.example.customEffectExample.show) ? _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(500),
      "effect": "blur"
    }
  }, [_c('img', {
    style: ({
      maxHeight: '200px',
      width: 'auto'
    }),
    attrs: {
      "src": require("../assets/v-api@512.png"),
      "alt": "Vue Api Request"
    }
  })]) : _vm._e()], 1)])])]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "creating-loader"
    }
  }, [_vm._v("Creating your own loader")]), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][9][2]))
    }
  }), _vm._v(" "), _c('p', [_vm._v("Setting your custom loader: ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][9][3]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][9][4]))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('customSpinnerExample')
      }
    }
  }, [_vm._v("Show Loader")])]), _vm._v(" "), _c('h4', [_vm._v("Example")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.example.customSpinnerExample.show) ? _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(2500),
      "spinner": "CustomLoader"
    }
  }, [_c('img', {
    style: ({
      maxHeight: '200px',
      width: 'auto'
    }),
    attrs: {
      "src": require("../assets/v-api@512.png"),
      "alt": "Vue Api Request"
    }
  })]) : _vm._e()], 1)])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "api"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("API Reference")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "props"
    }
  }, [_c('h3', [_vm._v("Props")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(31), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(32), _vm._v(" "), _c('td', [_vm._v("Function || Object")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("none")]), _vm._v(" "), _c('td', [_vm._m(33), _vm._v(" "), _c('h5', [_vm._v("Single request")]), _vm._v(" "), _c('ul', [_c('li', [_vm._m(34), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['apiReference']['props']['resource'][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['props']['resource'][1]))
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                      For this example, the response will be:\n                    ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['props']['resource'][2]))
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("Multiple Request")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("\n                      Also called as parallel request, it can call multiples APIs at the same and it only load when all APIs emit response.\n                      For this case, it has to be an "), _c('code', [_vm._v("Object")]), _vm._v(" whose its keys values need to be a "), _c('code', [_vm._v("Function")]), _vm._v("\n                      that returns a "), _c('code', [_vm._v("Promise")]), _vm._v(".\n                      See "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_9')
      }
    }
  }, [_vm._v("Parallel Requests")]), _vm._v(" section for details.\n                    ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['apiReference']['props']['resource'][3]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['props']['resource'][4]))
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                      For this example, the response will be:\n                    ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['apiReference']['props']['resource'][5]))
    }
  })])])])]), _vm._v(" "), _c('tr', [_vm._m(35), _vm._v(" "), _c('td', [_vm._v("any")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("null")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  If your resource functions have parameters, you can set here.\n                  See "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_2')
      }
    }
  }, [_vm._v("Request with Params")]), _vm._v(" section for details.\n                ")]), _vm._v(" "), _c('h5', [_vm._v("Single request")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("\n                      See example below:\n                    ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['apiReference']['props']['params'][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['props']['params'][1]))
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("Multiple request")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("\n                      See example below:\n                    ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['apiReference']['props']['params'][2]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['props']['params'][3]))
    }
  })])])])]), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('tr', [_vm._m(37), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._m(38), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._m(39), _vm._v(" "), _c('p', [_vm._v("\n                    If you have an older version, use\n                    "), _c('strong', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#methods_fetch')
      }
    }
  }, [_vm._v("\n                        fetch method\n                      ")])]), _vm._v(".\n                  ")])])])]), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _c('tr', [_vm._m(42), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _vm._m(43), _vm._v(" "), _c('td', [_vm._m(44), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['apiReference']['props']['resp'][0]))
    }
  }), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47)])]), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51)])])])]), _vm._v(" "), _vm._m(52), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "slots"
    }
  }, [_c('h3', [_vm._v("Slots")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(53), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(54), _vm._v(" "), _c('td', [_vm._m(55), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['slots']['default'][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['slots']['default'][1]))
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(56), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  This content is shown when the API from the component is waiting to be call.\n                ")]), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['slots']['waiting'][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['slots']['waiting'][1]))
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(59), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Replaces the standard loader and shows your custom loader.\n                  See also "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#conf-methods')
      }
    }
  }, [_vm._v("addLoader")]), _vm._v(" method.\n                ")])])]), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62)])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "methods"
    }
  }, [_c('h3', [_vm._v("Methods")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(63), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "id": "methods_fetch"
    }
  }, [_vm._m(64), _vm._v(" "), _vm._m(65), _vm._v(" "), _c('td', [_vm._v("\n                It calls the target API(s) instantly.\n                "), _c('h5', [_vm._v("Params")]), _vm._v(" "), _vm._m(66), _vm._v(" "), _c('h5', [_vm._v("Example")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['methods']['fetch'][0]))
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Example using key param")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['methods']['fetch'][1]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['methods']['fetch'][2]))
    }
  })])])])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "conf-methods"
    }
  }, [_c('h3', [_vm._v("Configuration Methods")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(67), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(68), _vm._v(" "), _vm._m(69), _vm._v(" "), _c('td', [_vm._v("\n                It will set the global "), _c('code', [_vm._v("$api")]), _vm._v(" variable.\n                See "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_4')
      }
    }
  }, [_vm._v("this example")]), _vm._v(".\n                "), _c('h5', [_vm._v("Params")]), _vm._v(" "), _vm._m(70)])]), _vm._v(" "), _c('tr', [_vm._m(71), _vm._v(" "), _vm._m(72), _vm._v(" "), _c('td', [_vm._v("\n                Add a custom effect.\n                "), _c('h5', [_vm._v("Params")]), _vm._v(" "), _c('ul', [_vm._m(73), _vm._v(" "), _c('li', [_c('code', [_vm._v("effect")]), _vm._v(": Function that makes the the effect.\n                    See "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#creating-effect')
      }
    }
  }, [_vm._v("this example")]), _vm._v(".\n                  ")])])])]), _vm._v(" "), _c('tr', [_vm._m(74), _vm._v(" "), _vm._m(75), _vm._v(" "), _c('td', [_vm._v("\n                Add a custom loader.\n                "), _c('h5', [_vm._v("Params")]), _vm._v(" "), _c('ul', [_vm._m(76), _vm._v(" "), _c('li', [_c('code', [_vm._v("component")]), _vm._v(": Component that will be used as loader.\n                    See "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#creating-loader')
      }
    }
  }, [_vm._v("this example")]), _vm._v(".\n                  ")])])])])])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "conf-options"
    }
  }, [_c('h3', [_vm._v("Configuration Options")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(77), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(78), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#props')
      }
    }
  }, [_vm._v("effect")]), _vm._v(" props.\n                  "), _c('br'), _vm._v("\n                  Props will replace if it is set.\n                ")])])]), _vm._v(" "), _c('tr', [_vm._m(79), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#props')
      }
    }
  }, [_vm._v("resp")]), _vm._v(" props.\n                  "), _c('br'), _vm._v("\n                  Props will replace if it is set.\n                ")])])]), _vm._v(" "), _c('tr', [_vm._m(80), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#props')
      }
    }
  }, [_vm._v("spinner")]), _vm._v(" props.\n                  "), _c('br'), _vm._v("\n                  Props will replace if it is set.\n                ")])])]), _vm._v(" "), _c('tr', [_vm._m(81), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#props')
      }
    }
  }, [_vm._v("spinner-color")]), _vm._v(" props.\n                  "), _c('br'), _vm._v("\n                  Props will replace if it is set.\n                ")])])]), _vm._v(" "), _c('tr', [_vm._m(82), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#props')
      }
    }
  }, [_vm._v("spinner-padding")]), _vm._v(" props.\n                  "), _c('br'), _vm._v("\n                  Props will replace if it is set.\n                ")])])]), _vm._v(" "), _c('tr', [_vm._m(83), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#props')
      }
    }
  }, [_vm._v("spinner-scale")]), _vm._v(" props.\n                  "), _c('br'), _vm._v("\n                  Props will replace if it is set.\n                ")])])]), _vm._v(" "), _c('tr', [_vm._m(84), _vm._v(" "), _vm._m(85), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#events')
      }
    }
  }, [_vm._v("@success")]), _vm._v(" event.\n                ")]), _vm._v(" "), _vm._m(86)])]), _vm._v(" "), _c('tr', [_vm._m(87), _vm._v(" "), _vm._m(88), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#events')
      }
    }
  }, [_vm._v("@error")]), _vm._v(" event.\n                ")]), _vm._v(" "), _vm._m(89)])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Package is installable via "), _c('strong', [_vm._v("NPM")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("or")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          via "), _c('strong', [_vm._v("Yarn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("or")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          via "), _c('strong', [_vm._v("CDN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          It will set "), _c('code', [_vm._v("window.VueApiRequest")]), _vm._v(" as the module.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://jsfiddle.net/gibranmax/everjv20/",
      "target": "_blank"
    }
  }, [_vm._v("See example in JSFiddle")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          In the first example, we gonna use a public API provided by\n          "), _c('a', {
    attrs: {
      "href": "https://developers.giphy.com/docs/",
      "target": "_blank"
    }
  }, [_vm._v("Giphy")]), _vm._v("\n          which will generate a random Gif every time\n          the component is mounted. Check it out:\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('h4', [_vm._v("Never do this, ever!")]), _vm._v(" "), _c('p', [_vm._v("\n            Normally, if you need params, you call the function like: "), _c('code', [_vm._v("func(a, b)")]), _vm._v(". However, using this concept\n            in "), _c('code', [_vm._v(":resource=\"giphyRandom('food', 'g')\"")]), _vm._v(", the component will not work properly.\n          ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Remind:")]), _vm._v(" The component requires a "), _c('code', [_vm._v("Function")]), _vm._v(" in "), _c('code', [_vm._v("resource")]), _vm._v(",\n            not its "), _c('code', [_vm._v("Promise Object")]), _vm._v(".\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Fake requests are useful for testing and other occasions.\n          You only need to create a "), _c('code', [_vm._v("Promise")]), _vm._v(" with "), _c('code', [_vm._v("setTimeout")]), _vm._v("\n          and return it in a function. See the example below:\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          It is possible to set global all your API Requests. To do this, let us create a new file "), _c('code', [_vm._v("api.js")]), _vm._v(":\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Here we import "), _c('code', [_vm._v("api.js")]), _vm._v(" and set it in VueApiRequest\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Now you have your APIs stored in the global variable "), _c('code', [_vm._v("$api")]), _vm._v(". To use it, follow the example:\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The "), _c('code', [_vm._v("Waiting Slot")]), _vm._v(" is very useful.\n          It keeps component in a standby state, holding the call.\n          So, you are allowed to call your API whenever you want by using "), _c('code', [_vm._v("sync")]), _vm._v(", "), _c('code', [_vm._v("trigger")]), _vm._v(" or "), _c('code', [_vm._v("fetch method")]), _vm._v(".\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          By default, if you don't have "), _c('code', [_vm._v("Waiting Slot")]), _vm._v(" or "), _c('code', [_vm._v("Success Slot")]), _vm._v(" set,\n          the "), _c('code', [_vm._v("Default Slot")]), _vm._v(" will be "), _c('code', [_vm._v("Success Slot")]), _vm._v("\n          and the component will not hold the API call (the call happens when the component is mounted).\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Other case, if there is only "), _c('code', [_vm._v("Waiting Slot")]), _vm._v(" set, the component will come back to this slot after the request is done (loaded).\n          This is can be useful for some situations like "), _c('strong', [_vm._v("toggle requests")]), _vm._v(" (e.g. Like Button).\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The "), _c('code', [_vm._v("trigger.sync")]), _vm._v(" parameter calls the API when its value is set to "), _c('strong', [_vm._v("true")]), _vm._v(".\n          After the call, this variable changes to "), _c('strong', [_vm._v("false")]), _vm._v(" automatically.\n          "), _c('br'), _vm._v("\n          In the first example, it shows you how to use "), _c('code', [_vm._v("trigger.sync")]), _vm._v(" by using like button.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Trigger.sync")]), _vm._v(" is only available in Vue 2.3.0+")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Result")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The "), _c('code', [_vm._v("sync")]), _vm._v(" parameter calls the API whenever its value changes.\n          "), _c('br'), _vm._v("\n          The next example is a "), _c('strong', [_vm._v("search query gif")]), _vm._v(" with pagination,\n          using "), _c('code', [_vm._v("sync")]), _vm._v(" and "), _c('code', [_vm._v("trigger.sync")]), _vm._v(".\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            For an unknown reason, you can't simply sync multi variables like this: "), _c('code', [_vm._v(":sync=\"[foo, bar]\"")]), _vm._v(".\n            It causes a weird bug which treats sync parameter as reactive with input event.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            A good solution is to use computed variable in sync parameter.\n            The example below you can use "), _c('code', [_vm._v(":sync=\"foobar\"")]), _vm._v(":\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Result")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Sometimes you need more than one request. There are many options to handle with that.\n          One way is to make "), _c('code', [_vm._v("Serial Requests")]), _vm._v(" which is basically stacks of requests.\n          It can be useful if one of request needs the data of the other one.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The example below loads three queue requests from "), _c('code', [_vm._v("fakeRequest")]), _vm._v(":\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          If some content uses data of many of requests, "), _c('code', [_vm._v("Parallel Requests")]), _vm._v(" can save you.\n          By this way, the content only shows when all of set of requests are successfully loaded.\n          Otherwise, it throws an error.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          This example is the same as "), _c('code', [_vm._v("Serial Requests")]), _vm._v(" showed before, but now all responses\n          appear at the same time when all of them load.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Free customize")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Using "), _c('code', [_vm._v("addEffect")]), _vm._v(" method, it is possible to create a new effect.\n          "), _c('a', {
    attrs: {
      "href": "//greensock.com"
    }
  }, [_vm._v("GreenSock")]), _vm._v(" provides a good way to customize your effect animation,\n          and it will be used in the next example:\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          You may also create your custom loader.\n          There are two ways: using "), _c('code', [_vm._v("addLoader")]), _vm._v(" method or using "), _c('code', [_vm._v("Loading Slot")]), _vm._v(".\n          The first option is more recommended.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The next example uses "), _c('code', [_vm._v("addLoader")]), _vm._v(" method, applying\n          "), _c('a', {
    attrs: {
      "href": "//fontawesome.io"
    }
  }, [_vm._v("Font Awesome")]), _vm._v(" as a custom spinner.\n          We gonna create a new component called "), _c('code', [_vm._v("CustomLoader.vue")]), _vm._v(":\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("resource")]), _c('strong', {
    staticClass: "grey"
  }, [_vm._v("(required)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  This is where you set your API. It can be "), _c('code', [_vm._v("single request")]), _vm._v("\n                  or "), _c('code', [_vm._v("multiple request")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                      This is usually the most used. For this case, it has to be a "), _c('code', [_vm._v("Function")]), _vm._v("\n                      that returns a "), _c('code', [_vm._v("Promise")]), _vm._v(".\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("params")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("sync")])]), _vm._v(" "), _c('td', [_vm._v("any")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("null")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  It calls API whenever it changes its value.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("trigger.sync")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  It calls API whenever it is set to "), _c('strong', [_vm._v("true")]), _vm._v(".\n                  It is automatically set to "), _c('strong', [_vm._v("false")]), _vm._v(" after the call.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Trigger.sync")]), _vm._v(" is only available in Vue 2.3.0+")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("only-if")])]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("true")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Your API is called only if this parameter is "), _c('strong', [_vm._v("true")]), _vm._v(".\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("effect")])]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("fadeIn")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  The effect to be shown when the content is loaded.\n                  These effects are provided by\n                  "), _c('a', {
    attrs: {
      "href": "https://daneden.github.io/animate.css/",
      "target": "_blank"
    }
  }, [_vm._v("Animate.css")]), _vm._v(".\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Recommended Effects:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', [_vm._v("fadeIn")]), _vm._v(",\n                  "), _c('code', [_vm._v("fadeInDown")]), _vm._v(",\n                  "), _c('code', [_vm._v("fadeInUp")]), _vm._v(",\n                  "), _c('code', [_vm._v("zoomIn")]), _vm._v(",\n                  "), _c('code', [_vm._v("zoomInDown")]), _vm._v(",\n                  "), _c('code', [_vm._v("zoomInUp")]), _vm._v(",\n                  "), _c('code', [_vm._v("bounceIn")]), _vm._v(",\n                  "), _c('code', [_vm._v("flipInX")]), _vm._v(",\n                  "), _c('code', [_vm._v("flipInY")]), _vm._v(",\n                  "), _c('code', [_vm._v("lightSpeedIn")]), _vm._v(",\n                  "), _c('code', [_vm._v("rotateInDownLeft")]), _vm._v(",\n                  "), _c('code', [_vm._v("rotateInDownRight")]), _vm._v(",\n                  "), _c('code', [_vm._v("rotateInUpLeft")]), _vm._v(",\n                  "), _c('code', [_vm._v("rotateInUpRight")]), _vm._v(",\n                  "), _c('code', [_vm._v("rollIn")]), _vm._v(",\n                  "), _c('code', [_vm._v("bounce")]), _vm._v(",\n                  "), _c('code', [_vm._v("flash")]), _vm._v(",\n                  "), _c('code', [_vm._v("pulse")]), _vm._v(",\n                  "), _c('code', [_vm._v("rubberBand")]), _vm._v(",\n                  "), _c('code', [_vm._v("shake")]), _vm._v(",\n                  "), _c('code', [_vm._v("swing")]), _vm._v(",\n                  "), _c('code', [_vm._v("tada")]), _vm._v(",\n                  "), _c('code', [_vm._v("wobble")]), _vm._v(",\n                  "), _c('code', [_vm._v("jello")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("resp")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "grey"
  }, [_vm._v(". "), _c('strong', [_vm._v("(dot)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  Path of response data. Imagine this "), _c('strong', [_vm._v("response")]), _vm._v(":\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  if "), _c('code', [_vm._v("resp=\"foo\"")]), _vm._v(", the response is actually "), _c('code', [_vm._v("response.foo")]), _vm._v(".\n                  "), _c('br'), _vm._v("\n                  if "), _c('code', [_vm._v("resp=\"foo.bar\"")]), _vm._v(", the response is actually "), _c('code', [_vm._v("response.foo.bar")]), _vm._v(".\n                  "), _c('br'), _vm._v("\n                  if "), _c('code', [_vm._v("resp=\".\"")]), _vm._v(", the response keeps in "), _c('code', [_vm._v("response")]), _vm._v(".\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  For "), _c('strong', [_vm._v("Vue Resource")]), _vm._v(" calls, this is usually set to "), _c('code', [_vm._v("body")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  For "), _c('strong', [_vm._v("axios")]), _vm._v(" calls, this is usually set to "), _c('code', [_vm._v("data")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("spinner")])]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("ClipLoader")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  The spinner to be shown when the content is loading.\n                  These spinners is provided by\n                  "), _c('a', {
    attrs: {
      "href": "http://greyby.github.io/vue-spinner/",
      "target": "_blank"
    }
  }, [_vm._v("greyby.github.io/vue-spinner/")]), _vm._v(".\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Available Spinners:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', [_vm._v("PulseLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("GridLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("ClipLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("RiseLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("BeatLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("SyncLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("RotateLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("FadeLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("PacmanLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("SquareLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("ScaleLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("SkewLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("MoonLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("RingLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("BounceLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("DotLoader")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("spinner-color")])]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("#42b983")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Hex color of Spinner.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("spinner-padding")])]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("1em")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Padding of Spinner.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("spinner-scale")])]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Size of Spinner. The value "), _c('code', [_vm._v("1")]), _vm._v("\n                  means its size is 100% of its original size.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    attrs: {
      "id": "events"
    }
  }, [_c('h3', [_vm._v("Events")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Parameters")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('code', [_vm._v("@waiting")])]), _vm._v(" "), _c('td', [_vm._v("none")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Emits when the API from the component is waiting to be call.\n                ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', [_vm._v("@loading")])]), _vm._v(" "), _c('td', [_vm._v("none")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Emits when the API from the component is loading.\n                ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', [_vm._v("@success")])]), _vm._v(" "), _c('td', [_vm._v("response")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Emits when the API from component returns a success response.\n                ")]), _vm._v(" "), _c('h5', [_vm._v("Params")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("response")]), _vm._v(": API response.\n                  ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', [_vm._v("@error")])]), _vm._v(" "), _c('td', [_vm._v("response")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Emits when the API from component returns a error response.\n                ")]), _vm._v(" "), _c('h5', [_vm._v("Params")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("response")]), _vm._v(": API response.\n                  ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', [_vm._v("@loaded")])]), _vm._v(" "), _c('td', [_vm._v("response")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Emits when the API from component returns a response (success or error).\n                ")]), _vm._v(" "), _c('h5', [_vm._v("Params")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("response")]), _vm._v(": API response.\n                  ")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("default")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  If there is no "), _c('code', [_vm._v("success slot")]), _vm._v(" or "), _c('code', [_vm._v("waiting slot")]), _vm._v(",\n                  it corresponds the "), _c('code', [_vm._v("success slot")]), _vm._v(".\n                  Otherwise, it is disabled.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("waiting")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("\n                    Note:\n                  ")]), _vm._v("\n                  if the "), _c('code', [_vm._v("waiting slot")]), _vm._v("\n                  slot is set, the component keeps its waiting state until you fetch it.\n                  Otherwise, the component automatically fetches it.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("\n                    Note:\n                  ")]), _vm._v("\n                  if there is no "), _c('code', [_vm._v("success slot")]), _vm._v(", "), _c('code', [_vm._v("error slot")]), _vm._v(" or "), _c('code', [_vm._v("loaded slot")]), _vm._v(", the state of the component will return to "), _c('code', [_vm._v("waiting")]), _vm._v("\n                  after it fetches and loaded.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("loading")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("success")])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  This content is shown when the API from component returns a success response.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("error")])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  This content is shown when the API from component returns a error response.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("loaded")])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  This content is shown when the API from component returns a response ("), _c('code', [_vm._v("success")]), _vm._v(" or "), _c('code', [_vm._v("error")]), _vm._v(").\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Parameters")]), _vm._v(" "), _c('th', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("fetch")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "grey"
  }, [_vm._v("String")]), _vm._v(" key")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('code', [_vm._v("key")]), _vm._v(": Name of API in the list to be call. If this parameter is not set, it will call all the APIs from the list.\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Parameters")]), _vm._v(" "), _c('th', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("setAPI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "grey"
  }, [_vm._v("Object")]), _vm._v(" api")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('code', [_vm._v("api")]), _vm._v(": Object to be set\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("addEffect")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "grey"
  }, [_vm._v("String")]), _vm._v(" name, "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("Function")]), _vm._v(" effect")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('code', [_vm._v("name")]), _vm._v(": Name of effect. It will replace if it already exists.\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("addLoader")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "grey"
  }, [_vm._v("String")]), _vm._v(" name, "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("Component")]), _vm._v(" component")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('code', [_vm._v("name")]), _vm._v(": Name of loader. It will replace if it already exists.\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("effect")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("resp")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("spinner")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("spinnerColor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("spinnerPadding")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("spinnerScale")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("onSuccess")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Function "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("(response)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("\n                    Note:\n                  ")]), _vm._v(" "), _c('code', [_vm._v("@success")]), _vm._v(" do not replace this event. Both two are executed in this case.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("onError")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Function "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("(response)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("\n                    Note:\n                  ")]), _vm._v(" "), _c('code', [_vm._v("@error")]), _vm._v(" do not replace this event. Both two are executed in this case.\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f0306b1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VueApiRequestDemo.vue
// module id = 169
// module chunks = 0